import { defineStore } from 'pinia';

/**
 * Restore payload:
 * { mode, plan_id, openMode, run_id?, source_run_id?, source_created_at?, source_display_name?, runRecords }.
 * openMode: 'view' | 'fork' | 'edit'
 */
export const useHistoryRestoreStore = defineStore('historyRestoreStore', {
  state: () => ({
    record: null,
  }),
  getters: {
    historyOpenMode(state) {
      return state.record?.openMode ?? null;
    },
    historyReadOnly(state) {
      return state.record?.openMode === 'view';
    },
  },
  actions: {
    setRecord(payload) {
      this.record = payload;
    },
    patchRecord(partial) {
      if (!this.record) return;
      this.record = { ...this.record, ...partial };
    },
    clearRecord() {
      this.record = null;
    },
  },
});
